import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const HeaderStyle = {
  container: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background-color: ${theme.colors.white};
  `,
  logoApp: css`
    height: auto;
    z-index: 1;
    display: flex;
    flex: 1;
    justify-content: center;
    cursor: pointer;
    text-decoration: underline;
    img {
      width: 100% !important;
      max-width: 5.5rem;
      vertical-align: middle;
    }
  `,
  menuButton: css`
    cursor: pointer;
    display: flex;
    flex: 1;
  `,
  menuLanguage: css`
    cursor: none;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    flex: 1;
    img {
      max-width: 1.5rem;
    }
    svg {
      width: 2rem;
      height: 2rem;
    }
    span {
      color: ${theme.colors.darkGreen};
    }
  `,
};
